// extracted by mini-css-extract-plugin
export default {"cell":"TableCell-module__cell__2vmPa","head":"TableCell-module__head__9pcVB","higher":"TableCell-module__higher__XiPZe"};